import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import MultiEnumFieldDetail from "./detail";
import MultiEnumFieldEdit from "./edit";
import MultiEnumFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type multienum en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function MultiEnum() {
    return _jsx(_Fragment, { children: " MultiEnum" });
}
var field = fieldsType.multienum;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, MultiEnumFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, MultiEnumFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, MultiEnumFieldList);
